<template>
  <AdminLayout>
  <div class="account-page py-4 mt-4">
    <div class="container">
      <div class="w-full main-card px-3 md:px-4 lg:px-5 py-4 lg:py-5 xl:py-7">
        <AdminsTable />
      </div>
    </div>
  </div>
  </AdminLayout>
</template>
<script>
import AdminLayout from '@/layouts/AdminLayout.vue';
import AdminsTable from './AdminsTable.vue';

export default {
  components: { AdminsTable, AdminLayout },
  data() {
    return {};
  },
  created() {},
  computed: {},
};
</script>
